<div class="c__content {{width !== DEFAULT_WIDTH ? 'has-width' : ''}}">
  <sd-banner [media]="media" [width]="width" />
</div>
